import React from 'react';
import { incluyeCadaTomo } from '../data/tomos';
export function Sistema() {
  return <section aria-labelledby="sistema-titulo" className="w-full bg-canvas px-6 py-20" data-id="element-188" data-mp="6a7eqq3uhjbf">
      <div className="mx-auto max-w-content text-center" data-id="element-189" data-mp="28capduj4rty">
        <p className="inline-flex rounded-full border border-brand-200 bg-brand-50 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-brand-700" data-id="element-190" data-mp="26sv7pgp6kt8">
          📦 Lo que incluye el sistema
        </p>

        <h2 id="sistema-titulo" className="mt-6 font-display text-3xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-191" data-mp="3ohnbjfpdfk23">
          Mega Pack Manicuría Lista Completo
        </h2>
        <p className="mx-auto mt-5 max-w-prose2 text-base leading-relaxed text-muted" data-id="element-192" data-mp="3enof8xbzaui2">
          El sistema de trabajo más completo disponible para manicuristas, técnicas de uñas y dueñas de
          estética de toda LATAM.
        </p>
        <p className="mx-auto mt-4 max-w-prose2 text-base leading-relaxed text-muted" data-id="element-193" data-mp="30pgaw4cm4qwv">
          Todo organizado en 6 tomos profesionales y 5 bonos especializados. Diseñado para que cada jornada
          sea más ordenada, más rentable y más segura.
        </p>

        <ul className="mx-auto mt-12 grid max-w-4xl gap-3 text-left sm:grid-cols-2" data-id="element-194" data-mp="160bmqv2aepi">
          {incluyeCadaTomo.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl border border-edge bg-surface px-5 py-4" data-id="element-195" data-mp="3oggjqly1riqm">
              <span aria-hidden="true" data-id="element-196" data-mp="g1y9cdkmvr3u">✅</span>
              <span className="text-sm leading-snug text-body" data-id="element-197" data-mp="k39ykhzliabi">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}